export default __webpack_public_path__ + "static/media/Graphics_Banner-2-min.4c89c9c1.png";